module.exports = __webpack_public_path__ + "img/avbuilder_cancel.5a92005d.svg";